import EChartsReact from 'echarts-for-react';
import React from 'react';
import { generateColors, getValueFromPercent } from 'utils/helpers';

interface IProps {
    orientation: 'horizontal' | 'vertical';
    showLabel: boolean;
    data: { name: string; value: number; value_percent: number }[];
    total: number;
}

const QuestionBarChart: React.FC<IProps> = ({
    orientation,
    showLabel,
    data,
    total,
}) => {
    const isHorizontal = orientation === 'horizontal';
    const colors = generateColors(data.length);
    return (
        <EChartsReact
            notMerge={true}
            style={{ height: 500 }}
            option={{
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                    },
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    formatter: function (params: any) {
                        let tooltipContent = `<strong>${params[0].axisValue}</strong><br/>`; // Hiển thị giá trị trục X

                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        params.forEach((item: any) => {
                            tooltipContent += `
                <span style="display:inline-block;width:10px;height:10px;
                background-color:${item.color};border-radius:50%;margin-right:5px;"></span>
                <strong>${getValueFromPercent(item.value, total, 0) ?? 0}</strong><br/>`;
                        });

                        return tooltipContent;
                    },
                },
                legend: {
                    type: 'scroll',
                },
                grid: {
                    left: '0%',
                    right: '5%',
                    bottom: '5%',
                    containLabel: true,
                },
                xAxis: isHorizontal
                    ? {
                          type: 'value',
                          boundaryGap: [0, 0.01],
                      }
                    : {
                          type: 'category',
                          data: data.map((item) => item.name),
                          show: data.length > 0,
                          axisLabel: {
                              formatter: function (value: string) {
                                  return value.length > 10
                                      ? value.substring(0, 10) + '...'
                                      : value;
                              },
                          },
                      },

                yAxis: isHorizontal
                    ? {
                          type: 'category',
                          data: data.map((item) => item.name),
                          show: data.length > 0,
                          axisLabel: {
                              formatter: function (value: string) {
                                  return value.length > 10
                                      ? value.substring(0, 10) + '...'
                                      : value;
                              },
                          },
                      }
                    : {
                          type: 'value',
                          boundaryGap: [0, 0.01],
                      },

                series: [
                    {
                        type: 'bar',
                        data: data.map((item) => item.value_percent ?? 0),
                        barWidth: 'auto',
                        barMinWidth: 5,
                        barMaxWidth: 50,
                        itemStyle: {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            color: (params: any) => {
                                return colors[params.dataIndex];
                            },
                        },
                        label: {
                            show: showLabel,
                            position: isHorizontal ? 'right' : 'top',
                            formatter: (params: { value: number }) => {
                                const value = params.value;
                                return `${value}%`;
                            },
                        },
                    },
                ],
                graphic: {
                    type: 'text',
                    left: 'center',
                    top: 'middle',
                    style: {
                        text: data.length > 0 ? '' : 'Không có dữ liệu',
                        fontSize: 16,
                        fill: '#888',
                    },
                },
            }}
        />
    );
};

export default QuestionBarChart;
